import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/next/dist/client/link.js");
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/components/copy-button/copy-button.tsx")